export default "__VITE_ASSET__BTByZwbM__"